import React from "react";
import Config from "./Configuration";

class PublicRelations extends React.Component
{
    constructor(props)
    {
        window.location.href = Config.base + '/news/public_relations';
        super();
    }

    render()
    {
        return (
            <>
            </>
        )
    }
}

export default PublicRelations;
